import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function () {
  const [update, setUpdate] = useState({});

  useEffect(() => {
    fetch('https://static.artex.dev/tacobell_update.json').then(r => r.json()).then(update => {
      const lastUpdate = localStorage.getItem('updateShown') ? JSON.parse(localStorage.getItem('updateShown')) : -1;
      if (update.id > lastUpdate)
        setUpdate(update);
    })
  }, [setUpdate])

  const hide = () => {
    localStorage.setItem('updateShown', JSON.stringify(update.id));
    setUpdate({});
  }

  return <Modal show={update.show} onHide={hide} scrollable>
    <Modal.Header closeButton>
      <Modal.Title>{update.title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div dangerouslySetInnerHTML={{ __html: update.body }} />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={hide}>Close</Button>
    </Modal.Footer>
  </Modal>
}